import { render, staticRenderFns } from "./MList.vue?vue&type=template&id=315f32bd&"
import script from "./MList.vue?vue&type=script&lang=js&"
export * from "./MList.vue?vue&type=script&lang=js&"
import style0 from "./MList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports